/**
 * @preserve SCS Tables, Third Generation.
 * Copyright (C) 2016 Software Consulting Services, LLC.
 */

function TableManager(tableName, extraParams, rootNode) {
  var tableVar = this;
  // Contstants
  var SORTABLE = {
    // Constants determining the type of column: checkbox, radio, textfield, etc.
    "COLUMN_TYPE_CHECKBOX" : '1',
    "COLUMN_TYPE_RADIO" : '2',
    "COLUMN_TYPE_TEXTFIELD" : '3',
    "COLUMN_TYPE_IMAGE" : '4',
    "COLUMN_TYPE_NORMAL" : '5',
    "COLUMN_TYPE_SELECTBOX" : '6',
    "COLUMN_TYPE_TOGGLE_ONE" : '7',
    "COLUMN_TYPE_TOGGLE_MULTIPLE" : '8',
    "COLUMN_TYPE_DATE" : '9',
    "COLUMN_TYPE_YEARMONTH" : '17',
    "COLUMN_TYPE_TIMESTAMP" : '10',
    "COLUMN_TYPE_FILE_SIZE" : '11',
    "COLUMN_TYPE_CURRENCY" : '12',
    "COLUMN_TYPE_BOOLEAN" : '13',

    // Constants determining the type of column filter: none, date, number, etc.
    "FILTER_TYPE_NONE" : '0',
    "FILTER_TYPE_DATE" : '1',
    "FILTER_TYPE_NUMBER" : '2',
    "FILTER_TYPE_STRING" : '3',
    "FILTER_TYPE_SINGLE_SELECT" : '4',
    "FILTER_TYPE_MULTI_SELECT" : '5',
    "FILTER_TYPE_SIZE" : '6',

    // Layout constants
    "FILTER_MULTI_SELECT_SIZE": 15,
  }
  window.SCS_TABLES3_SORTABLE = SORTABLE;
  // Utility functions
  function FilesizeToString(bytes) {
    if (Math.abs(bytes) < 1024)
        return bytes + 'B';
    var units = ['KB', 'MB', 'GB'];
    var u = -1;
    do {
        bytes /= 1024;
        ++u;
    } while (Math.abs(bytes) >= 1024 && u < units.length - 1);
    return bytes.toFixed(1) + units[u];
  }
  function formatSizeVal(v) {
    var n = parseFloat( v );
    var s = n.toFixed( 3 );
    while ( s.length < 10 ) {
      s = "0" + s;
    }
    return s;
  }
  function formatFilterVal( v, staticVal ) {
    /*
     * Replace all special lucene characters, these are:
     *   + - && || ! ( ) { } [ ] ^ " ~ * ? : \
     * We also replace spaces with and if the user typed this in.
     */
    if ( staticVal ) {
      return v.replace( /(\+|-|&&|\|\||!|\(|\)|\{|\}|\[|\]|\^|"|~|\*|\?|:|\\)/g, "\\$1" ).replace( / /g, "\\ " );
    }
    else {
      return v.replace( /(\+|-|&&|\|\||!|\(|\)|\{|\}|\[|\]|\^|"|~|\?|:|\\)/g, "\\$1" ).replace( / /g, " AND " );
    }
  };

  this._filterModal = (function ($header, callback) {
    var columnName = $header.attr('data-column-name'),
        columnId = $header.attr('data-column-id'),
        columnType = $header.attr('data-column-type'),
        filterType = $header.attr('data-filter-type'),
        filterCallback = $header.attr('data-filter-callback'),
        mtitle = $header.find('.th-left').text() + " Filter",
        priorFilter = this.filterObj[columnName];

    var $modal = $('#filterM'),
        $modalDialog = $modal.find('.modal-dialog'),
        $btnApply = $modal.find('[name=filterM_apply]'),
        $btnClose = $modal.find('[name=filterM_close]'),
        $btnClear = $modal.find('[name=filterM_clear]'),
        $form = $('<form class="form-inline text-center"></form>');

    $modal.find('.modal-title').text(mtitle);
    $modal.find('.modal-body').empty();
    $modalDialog.attr('class', 'modal-dialog');

    if (filterType == SORTABLE.FILTER_TYPE_NUMBER || filterType == SORTABLE.FILTER_TYPE_SIZE) {
      /* Number filter */
      var rowCt = 0;
      function addRow(formRow) {
        var $r = $('<div class="form-group filter' + filterType + '"></div>'),
            $operation = $('<select class="form-control" name="operator"></select>'),
            $num1 = $('<input type="number" class="form-control">'),
            $hidden = $('<span style="display:none"></span>'),
            $num2 = $('<input type="number" class="form-control">'),
            $addRow = $('<select class="form-control"></select>');
        $operation.append($('<option value="eq">is equal to</option>'))
                 .append($('<option value="lt">is less than</option>'))
                 .append($('<option value="le">is less than or equal to</option>'))
                 .append($('<option value="gt">is greater than</option>'))
                 .append($('<option value="ge">is greater than or equal to</option>'))
                 .append($('<option value="bt">is between</option>'))
                 .append($('<option value="neq">is not</option>'))
                 .append($('<option value="ot">is outside</option>'));
        $addRow.append($('<option value="end">-</option>'))
               .append($('<option value="and">and</option>'));
               //.append($('<option value="or">or</option>'))
               ;// TODO Or disabled because it doesn't work with the lucene filter?
        if ( !tableVar.extraParams?.isLucene ) {
          $addRow.append($('<option value="or">or</option>'));
        }
        if (filterType == SORTABLE.FILTER_TYPE_SIZE) {
          var $dimension = $('<select class="form-control"></select>');
          $dimension.append($('<option value="width">width</option>'))
                    .append($('<option value="height">height</option>'));
          $r.append($dimension);
        }
        $hidden.append('and').append($num2);
        $r.append($operation).append($num1).append($hidden).append($addRow);
        $form.append($r);
        rowCt++;
        if (formRow) {
          $operation.val(formRow[0]);
          $num1.val(formRow[1]);
          $num2.val(formRow[2]);
          $addRow.val(formRow[3]);
        }
        var curRow = rowCt;
        $r.find('select[name=operator]').change(function(e) {
          if (e.target.value == 'bt' || e.target.value == 'ot') {
            $hidden.show();
          }
          else {
            $hidden.hide();
            $num2.val('');
          }
          if (e.target.value == 'le' || e.target.value == 'ge')
            $operation.attr('style', 'width:40%');
          else
            $operation.attr('style', '');
        });
        $r.find('select:last-child').change(function(e) {
          if (e.target.value == 'end' && curRow < rowCt) {
            $form.find('div:gt(' + (curRow-1) + ')').remove();
            rowCt = curRow;
          }
          else if (curRow == rowCt) {
            addRow();
          }
        });
      }
      if (priorFilter && priorFilter.filter) {
        $.each(priorFilter.filter, function(i, e){addRow(e)});
      }
      else {
        addRow();
      }
    } else if ( filterType == SORTABLE.FILTER_TYPE_DATE ) {
      var rowCt = 0;
      function addRow( formRow ) {
        var $r = $( '<div class="form-group filter1"></div>' ),
            $contains = $( '<select class="form-control"></select>' ),
            $field = $( '<input type="date" class="form-control">' ),
            $addRow = $( '<select class="form-control"></select>' );
        $contains.append( $( '<option value="eq">is</option>' ) )
                 .append( $( '<option value="lt">is before</option>' ) )
                 .append( $( '<option value="gt">is after</option>' ) );
        $addRow.append( $( '<option value="end">-</option>' ) )
               .append( $( '<option value="and">and</option>' ) );
        if( !tableVar.extraParams?.isLucene) {
          $addRow.append( $( '<option value="or">or</option>' ) );
        }
        $r.append( $contains ).append( $field ).append( $addRow );
        $form.append( $r );
        rowCt++;
        if ( formRow ) {
          $contains.val( formRow[ 0 ] );
          $field.val( formRow[ 1 ] );
          $addRow.val( formRow[ 2 ] );
        }
        var curRow = rowCt;
        $r.find( "select:last-child" ).change( function ( e ) {
          if ( e.target.value == "end" && curRow < rowCt ) {
            $form.find( "div:gt(" + ( curRow - 1 ) + ")" ).remove();
            rowCt = curRow;
          } else if ( curRow == rowCt ) {
            addRow();
          }
        } );
      }
      if ( priorFilter && priorFilter.filter ) {
        $.each( priorFilter.filter, function ( i, e ) {
          addRow( e );
        } );
      } else {
        addRow();
      }
    }
    else if (filterType == SORTABLE.FILTER_TYPE_STRING) {
      /* String filter */
      var rowCt = 0;
      function addRow(formRow) {
        var $r = $('<div class="form-group filter3"></div>'),
            $contains = $('<select class="form-control"></select>'),
            $field = $('<input type="text" class="form-control">'),
            $addRow = $('<select class="form-control"></select>');
        $contains.append($('<option value="co">contains</option>'))
                 .append($('<option value="nco">does not contain</option>'));
        $addRow.append($('<option value="end">-</option>'))
               .append($('<option value="and">and</option>'));
               //.append($('<option value="or">or</option>'))
               ;// TODO Or disabled because it doesn't work with the lucene filter?
        if ( !tableVar.extraParams?.isLucene ) {
          $addRow.append($('<option value="or">or</option>'));
        }
        $r.append($contains).append($field).append($addRow);
        $form.append($r);
        rowCt++;
        if (formRow) {
          $contains.val(formRow[0]);
          $field.val(formRow[1]);
          $addRow.val(formRow[2]);
        }
        var curRow = rowCt;
        $r.find('select:last-child').change(function(e) {
          if (e.target.value == 'end' && curRow < rowCt) {
            $form.find('div:gt(' + (curRow-1) + ')').remove();
            rowCt = curRow;
          }
          else if (curRow == rowCt) {
            addRow();
          }
        });
      }
      if (priorFilter && priorFilter.filter) {
        $.each(priorFilter.filter, function(i, e){addRow(e)});
      }
      else {
        addRow();
      }
    }
    else if (filterType == SORTABLE.FILTER_TYPE_SINGLE_SELECT
          || filterType == SORTABLE.FILTER_TYPE_MULTI_SELECT) {
      var $div = $('<div class="form-group text-center"></div>'),
          $include = $('<input type="radio" value="co" name="co_nco" id="filter4include">'),
          $exclude = $('<input type="radio" value="nco" name="co_nco" id="filter4exclude">'),
          $select = $('<select class="form-control"></select>');

      if (filterType == SORTABLE.FILTER_TYPE_MULTI_SELECT)
        $select.attr('multiple', true);

      var selectList = [];
      var selectListCallback = function(list) {
        var selectSize = 0;
        $.map(list, function(obj) {
          $select.append($('<option value="' + obj.value + '">' + obj.display + '</option>'));
          selectSize++;
        });
        if (selectSize < SORTABLE.FILTER_MULTI_SELECT_SIZE) {
          $select.attr('size', selectSize);
          $select.css('overflow-y', 'hidden');
        }
        else {
          $select.attr('size', SORTABLE.FILTER_MULTI_SELECT_SIZE);
        }
      };

      // Get the select list data
      if (filterCallback) {
        selectListCallback( this[filterCallback](columnName) );
      }
      else if (columnType == SORTABLE.COLUMN_TYPE_BOOLEAN) {
        selectList = [{value: 'false', display: 'False'}, {value: 'true', display: 'True'}];
        selectListCallback(selectList);
      } else {
        var params = this._getRequestParams('list');
        $.extend( params,
            { col: columnId,
              dir: true,
              colname: columnName.toLowerCase() });
        Command(params, function(resp) {
          var valTableRows = resp.Table.Record;
          var valueList = $.map(valTableRows, function(row) {
            return {value: row.FILTERSORT, display: row.FILTERDISPLAY};
          });
          selectListCallback(valueList);
        });
      }

      $div.append(
        $('<label class="radio-inline" for="filter4include"></label>')
          .append($include).append("Include")
      );
      $div.append($('<label class="radio-inline" for="filter4exclude"></label>')
          .append($exclude).append("Exclude")
      );
      $div.append($('<br/>')).append($select);
      $include.prop('checked', true);
      if (priorFilter && priorFilter.filter) {
        if (priorFilter.filter[0] == 'nco')
          $exclude.prop('checked', true);
        $select.val(priorFilter.filter[1]);
      }
      $form.append($div);
    }
    else {
      $form.append('This form type has not been implemented.');
    }
    $modal.find('.modal-body').html($form);

    $modal.on('hidden.bs.modal', function (e) {
      $btnApply.off('click');
      $btnClose.off('click');
      $btnClear.off('click');
      $modal.off('hidden.bs.modal');
      if (callback)
        callback(); // wasn't dismissed via buttons
    });

    $btnClose.click(function() {
      var ret;
      if (callback)
        ret = callback();
      if (ret === false)
        return e.preventDefault();
      callback = undefined;
      $modal.modal('hide');
    });

    $btnClear.click(function() {
      var ret, obj = {};
      if (callback)
        obj[columnName] = {};
        ret = callback(obj);
      if (ret === false)
        return e.preventDefault();
      callback = undefined;
      $modal.modal('hide');
    });

    $btnApply.click(function() {
      var ret,
          formResult = {};
      if (callback) {
        /* Parse the form object for data to pass to the callback */
        if (filterType == SORTABLE.FILTER_TYPE_NUMBER ||
            filterType == SORTABLE.FILTER_TYPE_SIZE) {
          var filterList = [];
          $form.find('div').each(function(i, el) {
            var filter = [],
                $e = $(el);
            filter.push($e.find('select[name=operator]').val());
            filter.push($e.find('input:first').val());
            filter.push($e.find('select:last').val());
            filter.push($e.find('input:last').val());
            if (filterType == SORTABLE.FILTER_TYPE_SIZE)
              filter.push($e.find('select:first').val());
            if (filter[1] != "")
              filterList.push(filter);
          });
          if (filterList.length) {
            filterList[filterList.length - 1][2] = 'end';
            formResult[columnName] = {filterType: filterType, filter: filterList };
          }
        } else if ( filterType == SORTABLE.FILTER_TYPE_DATE ) {
          var filterList = [];
          $form.find( "div" ).each( function ( i, el ) {
            var filter = [],
                $e = $( el );
            filter.push( $e.find( "select:first-child" ).val() );
            filter.push( $e.find( "input" ).val() );
            filter.push( $e.find( "select:last-child" ).val() );
            if ( filter[ 1 ] != "" )
              filterList.push( filter );
          } );
          if ( filterList.length ) {
            filterList[ filterList.length - 1 ][ 2 ] = "end";
            formResult[ columnName ] = { filterType: filterType, filter: filterList };
          }
        }
        else if (filterType == SORTABLE.FILTER_TYPE_STRING) {
          var filterList = [];
          $form.find('div').each(function(i, el) {
            var filter = [],
                $e = $(el);
            filter.push($e.find('select:first-child').val());
            filter.push($e.find('input').val());
            filter.push($e.find('select:last-child').val());
            if (filter[1] != "")
              filterList.push(filter);
          });
          if (filterList.length) {
            filterList[filterList.length - 1][2] = 'end';
            formResult[columnName] = {filterType: filterType, filter: filterList };
          }
        }
        else if (filterType == SORTABLE.FILTER_TYPE_SINGLE_SELECT ||
                 filterType == SORTABLE.FILTER_TYPE_MULTI_SELECT) {
          var modifier = $form.find('[name=co_nco]:checked').val(),
              conjunction = (modifier == "co")? "or": "and",
              filterList = [],
              values = $form.find("select").val();

          if (typeof values == "string") {
            values = [values];
          }
          $.each(values, function(i, e) {
            var filter = [modifier, e, conjunction];
            filterList.push(filter);
          });
          if (filterList.length) {
            filterList[filterList.length - 1][2] = 'end';
            formResult[columnName] = {filterType: filterType, filter: filterList };
          }
        }
        ret = callback(formResult);
      }
      if (ret === false)
        return e.preventDefault();
      callback = undefined;
      $modal.modal('hide');
    });

    $modal.modal('show');
    $form.find('input').focus();
    $form.keypress(function (e) {
      if (e.which == 13)
        $btnApply.click();
    });
  }).bind(this);

  // Private data
  this.p = {};
  this.p.tableName = tableName;

  // Elements
  this.p.$rootNode = rootNode ? rootNode : $("#Tables3_" + tableName);

  if (!this.p.$rootNode.length)
    return console.error("Could not find root node");
  this.p.$style = this.p.$rootNode.find("style"),
  this.p.$dimmer = this.p.$rootNode.find("div.dimmer"),
  this.p.$thead = this.p.$rootNode.find("table tr.thead"),
  this.p.$tbody = this.p.$rootNode.find("table tbody"),
  this.p.$tcaption = this.p.$rootNode.find("div.caption-info"),
  this.p.$btnPerpage = this.p.$rootNode.find(".perpage-dropdown button.btn"),
  this.p.$mnuPerpage = this.p.$rootNode.find(".perpage-dropdown ul.dropdown-menu"),
  this.p.$pagination = this.p.$rootNode.find("ul.pagination"),
  this.p.$pagFirst = this.p.$pagination.find("li a.first").parent(),
  this.p.$pagLast = this.p.$pagination.find("li a.last").parent(),
  this.p.$btnCSV = this.p.$rootNode.find("button.btnCSV"),
  this.p.$btnPDF = this.p.$rootNode.find("button.btnPDF"),
  this.p.$btnFilter = this.p.$rootNode.find("button.btnFilter"),
  this.p.$btnEditColumns = this.p.$rootNode.find("button.btnEditColumns");
  // Parameters
  this.perPage = extraParams ? extraParams[ "perPage" ] ? extraParams[ "perPage" ] : "25" : "25";
  this.pages = 1;
  this.currentPage = 1;
  this.numberOfRows = 0;

  this.tableUpdateCallback = undefined;
  this.extraParams = extraParams ? extraParams : {};
  this.filterObj = undefined;
  /* Typescript documentation of the structure of this.filterObj. See also above in this file
     where FilterObjs are built from a UI.

  type FilterObj = Record<string, ColumnFilter> // where the string key is the column to be filtered

  type Conjunction = "end" | "and" | "or"
  type DateOperator =   "eq" // is
                      | "lt" // is before
                      | "gt" // is after

  type DateFilter = [DateOperator, string, Conjunction]
  type NumberOrSizeSingleArgumentOperator = 	  "eq" // is equal to
                                              | "lt" // is less than
                                              | "le" // is less than or equal to
                                              | "gt" // is greater than
                                              | "ge" // is greater than or equal to
                                              | "neq" // is not equal to

  type NumberOrSizeDualArgumentOperator = 	  "bt" // is between
                                            | "ot" // is outside

  type NumberFilter = [
      NumberOrSizeSingleArgumentOperator | NumberOrSizeDualArgumentOperator,
      string, // first argument
      Conjunction,
      string // possible second argument
  ]
  type SizeFilter = [
    NumberOrSizeSingleArgumentOperator | NumberOrSizeDualArgumentOperator,
    string,  // first argument
    Conjunction,
    string,  // possible second argument
    "width" | "height"
  ]

  type StringOperator =   "co" 	// contains
                        | "nco" // does not contain

  type StringFilter = [ StringOperator, string, Conjunction ]

  type SelectFilter = StringFilter

  type Filter = DateFilter | NumberFilter | SizeFilter | StringFilter | SelectFilter

  type ColumnFilter = {
    filterType: string,
    filter: Filter[]
  }
  */


  this.sortDirection = extraParams?.initSort?.dir ? extraParams?.initSort?.dir === "asc" : true; // Descending
  this.sortColumn = extraParams?.initSort?.col ?? 0; // null
  this.visibleColumns = []; // If empty, all columns are visible
  this.hiddenColumns = [];
  this.p.originalColumns = []; // The columns as they were on load
  this.p.columns = {};

  this.checkKey = undefined; // Data key that checkboxes use to store their data
  this.checked = [];
  this.checkCallback = undefined;

  this.p.initialInit = true;
  // Cached data
  var rU = this.p.$rootNode.attr("data-refresh-url"),
      lU = this.p.$rootNode.attr("data-load-url");
  this.p.cmdRefresh = rU.substr(rU.indexOf("command=") + "command=".length);
  this.p.cmdLoad = lU.substr(lU.indexOf("command=") + "command=".length).trim();
  this.p.tableCGI = rU.substr(0, rU.indexOf("?"));
  // If the full path is not in the URL, use the cgi in the page parameters
  if ($.QueryString.cgi && $.QueryString.cgi in CGI_MAP && this.p.tableCGI == "spice.pl") {
    this.p.tableCGI = APP_URLs[CGI_MAP[$.QueryString.cgi]];
  }
  this.p.rawExtraParams = this.p.$rootNode.attr("data-extra-params");
  this.p.tableTitle = this.p.$rootNode.attr("data-bs-title");
  this.p.defaultExtraParams = {};
  this.p.refreshInProgress = false;
  this.p.resetInProgress = false;
  if (rU.indexOf("command=") == -1)
    this.p.cmdRefresh = '';
  if (lU.indexOf("command=") == -1)
    this.p.cmdLoad = '';
  if ((!this.p.cmdRefresh && !this.p.rawExtraParams) || !this.p.tableCGI) {
    console.error("Could not load table '" + this.p.tableName +
      "': missing both 'load'/'refresh' and 'extraparams'.");
    return;
  }
  if (this.p.rawExtraParams) {
    this.p.rawExtraParams = this.p.rawExtraParams.trim();
    // Since some tables don't use the "command" but rather use a "form_id"
    // plus another ID or the like, we have to have "extra load params".
    var a = this.p.rawExtraParams.split("&");
    for (var i in a) {
      var s = a[i].split("=");
      this.p.defaultExtraParams[s[0]] = s[1];
    }
    // Turn on display of the table title and information line.
    if (this.p.defaultExtraParams["displayTitle"] === "true")
       this.p.$rootNode.find("#" + this.p.tableName + "-caption-title").removeClass("hidden");
    if (this.p.defaultExtraParams["displayInfo"] === "false")
       this.p.$rootNode.find("#" + this.p.tableName + "-caption-info").addClass("hidden");
  }
  // Parse 'data-extra-params'
  try {
    this.hiddenColumns = JSON.parse(this.p.$rootNode.attr("data-extra-params")).hiddenColumns;
    this.p.$rootNode.removeAttr("data-extra-params");
  } catch (e) {  }

  // Helper functions
  this._updatePagination = (function (newPages, newCurrentPage) {
    if (this.p.initialInit || newPages != this.pages || newPages > 4) {
      this.p.$pagination.find('li.page-item').remove();
      if ((newPages === newCurrentPage) && (newPages <= 1) && (newCurrentPage <= 1)) { // hide page controls if it is only one page
        this.p.$pagination.hide()
        if (this.numberOfRows <= 10) { // hide number of rows dropdown if <= 10 rows
          this.p.$btnPerpage.hide()
        }
      }
      else {
        this.p.$pagination.show()
        this.p.$btnPerpage.show()
        var buf = '', i = 0, l = newPages;
        if (newPages > 4) {
          i = Math.max(0, newCurrentPage - 2);
          l = Math.min(newPages, newCurrentPage + 1);
          if ((l - i) < 4) { // One of the params was bounded
            var diffTo4 = 4 - (l - i);
            i = Math.max(0, newCurrentPage - (2 + diffTo4));
            l = Math.min(newPages, newCurrentPage + 1 + diffTo4);
          }
        }
        if (i > 0)
          buf += '<li class="disabled page-item"><a draggable="false" class="page-link" disabled href="#">...</a></li>';
        for (; i < l; i++)
          buf += '<li class="page-item" data-page="' + (i + 1) +
            '"><a draggable="false" class="page-link" href="#">' + (i + 1) + '</a></li>';
        if (l != newPages)
          buf += '<li class="disabled page-item"><a draggable="false" class="page-link" disabled href="#">...</a></li>';
        this.p.$pagFirst.after(buf);
      }
    }
    this.pages = newPages;
    this.currentPage = newCurrentPage;
    if (newPages == this.currentPage)
      this.p.$pagLast.addClass("disabled");
    else
      this.p.$pagLast.removeClass("disabled");
    if (this.currentPage < 2) // zero or one
      this.p.$pagFirst.addClass("disabled");
    else
      this.p.$pagFirst.removeClass("disabled");
    this.p.$pagination.find("li.page").removeClass('active');
    this.p.$pagination.find("li.page[data-page='" + this.currentPage + "']")
      .addClass('active');
  }).bind(this);
  this._updateHeader = (function (resp, sortColumn) {
    this.p.columns = [];
    this.p.$thead.find("th").each((function (i, e) {
      var $ej = $(e);
      this.p.columns[i] = {
        name: $ej.attr("data-column-name"),
        type: $ej.attr("data-column-type"),
        alignment: $ej.attr("data-alignment"),
      };
    }).bind(this));
    this.p.$thead.find("th i.fa-sort-amount-asc")
      .removeClass("fa-sort-amount-asc").addClass("fa-sort");
    this.p.$thead.find("th i.fa-sort-amount-desc")
      .removeClass("fa-sort-amount-desc").addClass("fa-sort");
    this.p.$thead.find("th[data-column-id='" + sortColumn + "'] i")
      .addClass((resp.SortDirection == "1") ?
        "fa-sort-amount-asc" : "fa-sort-amount-desc");
    this.p.$thead.find("th[data-sortable='false'][data-filter-type!=0] i")
      .removeClass("fa-sort").addClass('fa-filter');
    this.p.$tcaption.text(resp.TableMessage);
  }).bind(this);
  this._rebuildTable = (function (records) {
    // Clear old state
    this.p.$tbody.empty();
    this.p.$thead.find("[data-column-type=1] input").prop("checked", false);

    if (!records)
      return; // Not necessarily an error - table could be empty
    if (!("0" in records))
      records = [records]; // Only one item, encase it in an array

    this.p.$tbody.data("raw", records);

    const contextMenuItems = this.extraParams?.rowContextMenuItems
    const tableManager = this

    for (var i in records) {
      var $tr = $("<tr/>");
      if (contextMenuItems) {
        $tr.on("contextmenu", function(e) { // setup context menu on row, target will be cell
          e.preventDefault();
          const rowData =  $($(e.target).parent()).data("raw")
          function contextMenuCallback(option) {
            const item = contextMenuItems.find(i => i.title === option.title)
            if (item) {
              item.func(tableManager, rowData, $(e.target).parent())
            }
          }
          const popupOptions = contextMenuItems.map(i => ({ title: i.title, value: i.title, disabled: i.conditionFunc && !i.conditionFunc(rowData) }))
          popupMenu( 'popup' + rowData.RowNumber, {
            callback: contextMenuCallback,
            optionsList: popupOptions,
            event: e }, true );
        })
      }
      for (var j in this.p.columns) {
        var $td = $("<td></td>");
        var str = records[i][this.p.columns[j].name];
        if ((str == null || str == undefined) &&
            (this.p.columns[j].type != SORTABLE.COLUMN_TYPE_CHECKBOX
                && (this.p.columns[j].type != SORTABLE.COLUMN_TYPE_RADIO))) {
          $tr.append("<td></td>");
          continue;
        }

        if ( this.p.columns[j].alignment == "center" ) {
          $td = $('<td class="td_center"></td>');
        } else if ( this.p.columns[j].alignment == "right" ) {
          $td = $('<td class="td_right"></td>');
        } else if ( this.p.columns[j].alignment == "left" ) {
          $td = $('<td class="td_left"></td>');
        }

        switch (this.p.columns[j].type) {
          case SORTABLE.COLUMN_TYPE_CHECKBOX: {
            str = $('<input type="checkbox"></input>');
            if (this.checkKey && this.checkKey !== "ALL") {
              str.prop("checked",
                this.checked.indexOf(records[i][this.checkKey]) != -1);
              str.click((function (e) {
                var $tr = $(e.target).parent().parent(),
                  value = $tr.data("raw")[this.checkKey],
                  idx = this.checked.indexOf(value);
                if ($(e.target).prop("checked") && idx == -1) {
                  this.checked.push(value);
                } else if (!$(e.target).prop("checked") && idx != -1) {
                  this.checked.splice(idx, 1);
                }
                if (this.checkCallback)
                  this.checkCallback();
              }).bind(this));
            }
            else if (this.checkKey === "ALL") {
              str.click((function (e) {
                var $tr = $(e.target).parent().parent(),
                record = $tr.data("raw")
                const idx = this.checked.findIndex(r => JSON.stringify(r) === JSON.stringify(record));
                if ($(e.target).prop("checked") && idx == -1) {
                  this.checked.push(record);
                } else if (!$(e.target).prop("checked") && idx != -1) {
                  this.checked.splice(idx, 1);
                }
                if (this.checkCallback)
                  this.checkCallback();
              }).bind(this));
            }
          } break;
        case SORTABLE.COLUMN_TYPE_RADIO:
          str = '<input type="radio"></input>'; break;
        case SORTABLE.COLUMN_TYPE_DATE:
          str = tsToStr(str, true);
        break;
        case SORTABLE.COLUMN_TYPE_YEARMONTH:
          if (str === "00000000") {
            str = "";
          } else {
            str = str.substring(4, 6)+" / "+str.substring(0,4);
          }
        break;
        case SORTABLE.COLUMN_TYPE_TIMESTAMP:
          str = tsToStr(str, false);
        break;
        case SORTABLE.COLUMN_TYPE_FILE_SIZE:
          str = FilesizeToString(parseInt(str)); break;
        case SORTABLE.COLUMN_TYPE_CURRENCY: {
          $td.addClass("currency");
          str = FormatCurrency(str);
        } break;
        case SORTABLE.COLUMN_TYPE_BOOLEAN: {
          str = str ? '<i class="fa fa-check"></i>' : '';
        } break;
        default: if (this.escapeStrings) str = $('<div/>').text(str).html(); break;
        }
        $tr.append($td.append(str));

        // Attach the raw data to the row, so tableUpdateCallback() or others
        // can access it later.
        $tr.data("raw", records[i]);
      }
      this.p.$tbody.append($tr);
    }
    if (this.tableUpdateCallback)
      this.tableUpdateCallback(this.p.$tbody);
  }).bind(this);
  this._generateLuceneFilterParams = (function (overrideFilterObj) {
    /* Adds to the filterString in extraParams using the filterObjects
          created by user using the filter modal.*/
    let filterObj = overrideFilterObj ?? this.filterObj;
    let builtColFilters = [];

    for (const colName in filterObj) {
      const colFilter = filterObj[colName];

      let builtColFilter = "";
      let previouslySetNextConjunction = "start";
      function appendFilterSegment(luceneFilterStr, nextConjunction) {
        switch (previouslySetNextConjunction) {
          case "start":

            break;
          case "and":
            builtColFilter += " AND ";
            break
          case "or":
            builtColFilter += " OR ";
            break
          case "end":
            builtColFilter += " AND ";
            break
        }
        builtColFilter += `(${luceneFilterStr})`;
        previouslySetNextConjunction = nextConjunction;
      }

      const filterType = colFilter.filterType;
      const filterList = colFilter.filter;
      for (const filter of filterList) {
        switch (filterType) {
          case SORTABLE.FILTER_TYPE_NUMBER:
          case SORTABLE.FILTER_TYPE_SIZE: {
            const [operator, arg1, nextConjunction, arg2, widthOrHeight] = filter;
            const colNameToWrite = (filterType === SORTABLE.FILTER_TYPE_SIZE ? widthOrHeight : colName).toLowerCase();

            let luceneFilterStr = "";
            switch (operator) {
              case "eq": { // equal to
                luceneFilterStr = `${colNameToWrite}:(${formatSizeVal(arg1)})`;
              } break;
              case "lt": { // less than
                 // TODO: Does this actually work with our version of Lucene? If not, use the
                 // hack with ranges and wildcards used below for date inequality checking.
                 // (e.g., make this filter here be `${colNameToWrite}:{* TO ${formatSizeVal(arg1)})}`)
                 // See also: https://stackoverflow.com/a/23681456
                luceneFilterStr = `${colNameToWrite}:(<${formatSizeVal(arg1)})`;
              } break;
              case "le": { // less than or equal to
                luceneFilterStr = `${colNameToWrite}:(<=${formatSizeVal(arg1)})`;
              } break;
              case "gt": { // greater than
                luceneFilterStr = `${colNameToWrite}:(>${formatSizeVal(arg1)})`;
              } break;
              case "ge": { // greater than or equal to
                luceneFilterStr = `${colNameToWrite}:(>=${formatSizeVal(arg1)})`;
              } break;
              case "neq": { // not equal to
                luceneFilterStr = `NOT (${colNameToWrite}:(${formatSizeVal(arg1)}))`;
              } break;
              case "bt": { // is between
                luceneFilterStr = `${colNameToWrite}:[${formatSizeVal(arg1)} TO ${formatSizeVal(arg2)}]`;
              } break;
              case "ot": { // is outside
                luceneFilterStr = `NOT (${colNameToWrite}:[${formatSizeVal(arg1)} TO ${formatSizeVal(arg2)}])`;
              } break;
            }
            if (luceneFilterStr) {
              appendFilterSegment(luceneFilterStr, nextConjunction);
            }
          } break;
          case SORTABLE.FILTER_TYPE_STRING:
          case SORTABLE.FILTER_TYPE_SINGLE_SELECT:
          case SORTABLE.FILTER_TYPE_MULTI_SELECT: {
            const [operator, str, nextConjunction] = filter;
            const colNameToWrite = colName.toLowerCase();
            switch (operator) {
              case "co": { // contains
                appendFilterSegment(`${colNameToWrite}:"${formatFilterVal(str, true)}"`, nextConjunction);
              } break;
              case "nco": { // does not contain
                appendFilterSegment(`NOT (${colNameToWrite}:"${formatFilterVal(str, true)}")`, nextConjunction);
              } break;
            }
          } break;
          case SORTABLE.FILTER_TYPE_DATE: {
            let luceneFilterStr = "";
            const colNameToWrite = colName.toLowerCase();
            let nextConjunction = "end"
            if (filter.length === 6) { // has greater than and less than date filters
              const gtNormalized = filter[1].replace(/\D/g, "");
              const ltNormalized = filter[4].replace(/\D/g, "")
              luceneFilterStr = `${colNameToWrite}:[${gtNormalized} TO ${ltNormalized}]`;
            }
            else { // has only one date filter
              const [operator, dateStr] = filter;
              nextConjunction = filter[2]
              const dateStrNormalized = dateStr.replace(/\D/g, "");

              switch (operator) {
                case "eq": { // equal to
                  luceneFilterStr = `${colNameToWrite}:(${dateStrNormalized})`;
                } break;
                case "lt": { // is before
                  luceneFilterStr = `${colNameToWrite}:[* TO ${dateStrNormalized}]`;
                } break;
                case "gt": { // is after
                  // For some reason the wildcard works above but not here ¯\_(ツ)_/¯, so we do this hack.
                  luceneFilterStr = `${colNameToWrite}:[${dateStrNormalized} TO 22000101]`;
                } break;
              }
            }

            if (luceneFilterStr) {
              appendFilterSegment(luceneFilterStr, nextConjunction);
            }
          } break;
          default:
            console.warn("Unrecognized filter type in ", colFilter);
            break;
        }
      }

      builtColFilters.push(`(${builtColFilter})`);
    }
  
    const builtFilter = builtColFilters.join(" AND ");
    this.extraParams['lucenefilter'] = builtFilter;
  }).bind(this);
  this._generateFilterParams = ( function (customFilterBlob) {
    var filterObj = this.filterObj;
    var filterString = "";
    if ( !$.isEmptyObject( filterObj ) )
      filterString = "`r\nv2";
    var columnJoin = false;
    var tableVar = this;
    $.each( filterObj, function ( columnName, columnFilter ) {
      var filter = columnFilter.filter;
      var filterType = columnFilter.filterType;
      var postFixExpression = "";
      var firstColumn = true;
      $.each( filter, function ( i, f ) {
        filterString += "\ndc:" + tableVar.ColumnId( columnName ) + "\n";
        switch ( filterType ) {
          case SORTABLE.FILTER_TYPE_DATE:
            var date = f[ 1 ].replace( /-/g, "" );
            if ( f[ 0 ] == "lt" ) {
              filterString += "hv:" + date;
            } else if ( f[ 0 ] == "gt" ) {
              filterString += "lv:" + date;
            } else {
              filterString += "vl:" + date;
            }
            filterString += "\n";
            break;
          case SORTABLE.FILTER_TYPE_SINGLE_SELECT:
          case SORTABLE.FILTER_TYPE_MULTI_SELECT:
            filterString += "vl:" + f[ 1 ] + "\n";
            break;
          default:
            if ( f[ 1 ].includes( "*" ) ) {
              filterString += "vl:" + f[ 1 ] + "\n";
            } else {
              filterString += "vl:*" + f[ 1 ] + "*\n";
            }
            break;
        }
        filterString += "cs:N\n";
        if ( f[ 0 ] == "neq" || f[ 0 ] == "nco" ) {
          filterString += "end\nnot";
        } else {
          filterString += "end";
        }
        if ( columnJoin && firstColumn ) {
          filterString += "\nand";
          firstColumn = false;
        }
        if ( postFixExpression != "" ) {
          filterString += "\n" + postFixExpression;
        }
        postFixExpression = f[ 2 ];
      } );
      columnJoin = true;
    } );
    if ( filterString.length != 0 )
      filterString += "\n`";
    if (!!customFilterBlob) {
       filterString += customFilterBlob;
    }
    this.extraParams[ "filterblob" ] = filterString;
  } ).bind( this );
  this._getRequestParams = (function (nav, customFilterBlob) {
    var useLoadCmd = (nav == 'init') && (!!this.p.cmdLoad);
    var params = {
      cgi: this.p.tableCGI,
      method: 'POST',
      command: useLoadCmd ? this.p.cmdLoad : this.p.cmdRefresh,
      tableid: tableName,
      listrows: this.perPage,
      gridrows: this.perPage,
      nav: nav ? nav : "goto",
      page: this.currentPage + ""
    };
    if ( this.extraParams?.isLucene ) {
      this._generateLuceneFilterParams(nav === "init" ? this.extraParams.initLuceneFilter : (this.filterObj ?? this.extraParams.initLuceneFilter));
    } else {
      this._generateFilterParams(customFilterBlob);
    }
    for (var i in this.p.defaultExtraParams)
      params[i] = this.p.defaultExtraParams[i];
    for (var i in this.extraParams)
      params[i] = this.extraParams[i];

    // for params that change on the fly, like search params
    if (this.extraParams.getParams) {
      const getParamsResult = this.extraParams.getParams()
      for(var i in getParamsResult) {
        params[i] = getParamsResult[i]
      }
    }
    if (this.sortColumn != 0) {
      if (this.extraParams?.isLucene) {
        params.luceneSort =
          'fieldname,direction\n' +
          this.p.$thead.find("th[data-column-id='" + this.sortColumn + "']")
                  .attr('data-column-name') + "," +
          (this.sortDirection ? "asc" : "desc") + "\n";
      }
      params.col = this.sortColumn + "";
      params.dir = this.sortDirection + "";
    }
    // delete so these don't go across in network request unnecessarily
    delete params.initLuceneFilter
    delete params.initSort
    delete params.rowContextMenuItems
    delete params.getParams
    return params;
  }).bind(this);
  // Public member functions
  this.ColumnIndex = (function (colName) {
    var $el = this.p.$thead.find("th[data-column-name='" + colName +"']");
    if (!$el.length)
      return;
    return $el.index() + 1;
  }).bind(this);
  this.ColumnId = (function (colName) {
    // Return the back-end id of a column. Needed for filtering.
    var $el = this.p.$thead.find("th[data-column-name='" + colName +"']");
    if (!$el.length)
      return -1;
    return $el.attr("data-column-id");
  }).bind(this);
  this.UpdateColumns = (function () {
    if (!this.p.originalColumns.length) {
      this.p.originalColumns = this.p.$thead.find("th").map(function ()
        { return this.getAttribute('data-column-name'); }).get();
    }
    if (!this.hiddenColumns || !this.hiddenColumns.length) {
      this.visibleColumns = this.p.originalColumns.slice();
      this.p.$style.html("");
      return;
    }
    else {
      this.visibleColumns = [];
      var elements = this.p.$thead.find("th").get();
      for( let i = 0; i < elements.length; i++){
	  if(!this.hiddenColumns.includes(elements[i].getAttribute('data-column-name'))){
	      this.visibleColumns.push(elements[i].getAttribute('data-column-name'));
	  }
      }
    }

    var hiddenColumns = this.hiddenColumns;
    var elements = this.p.$thead.find("th").get();
    for (var i = 0; i < elements.length; i++)
      elements[i].parentNode.appendChild(elements[i]);

    var style = "";
    for (var i in hiddenColumns) {
      var col = this.ColumnIndex(hiddenColumns[i]);
      style += "#Tables3_" + tableName + " th:nth-child(" + col + "), ";
      style += "#Tables3_" + tableName + " td:nth-child(" + col + ")";
      style += " { display: none; }\n";
    }
    this.p.$style.html(style);
    this.Refresh();
  }).bind(this);
  this.Sort = ( function ( dir, col ) {
    if ( isUndefinedOrNull( dir ) )
      return;
    if ( isUndefinedOrNull( col ) )
      col = this.sortColumn;
    this.sortDirection = dir;
    this.sortColumn = col;
    var params = this._getRequestParams( "sort" );
    params.col = col;
    params.dir = dir;
    params.nav = "new_sort";
    Command( params, ( function ( r ) {
      this.Refresh();
    } ).bind( this ) );
  } ).bind( this );
  this.Refresh = (function (nav, callback, customFilterBlob) {
    if (this.p.refreshInProgress)
      return;
    this.p.refreshInProgress = true;
    for ( var key in this.filterObj ) {
      if ( !Object.keys( this.filterObj[ key ] ).length ) {
        delete this.filterObj[ key ];
      }
    }
    this.p.$dimmer.show();
    var params = this._getRequestParams(nav, customFilterBlob);
    Command(params, (function (r) {
      this.p.refreshInProgress = false;
      if (r.error) {
        // Only try this once if we get another error to avoid inf. recursion
        if (!this.p.resetInProgress) {
          this.p.resetInProgress = true;
          this.Refresh("init");
        }
        return;
      }
      this.numberOfRows = r.Table.TotalNumberOfRows;
      this.p.resetInProgress = false;
      var resp = r.Table;
      this._updatePagination(parseInt(resp.TotalPages), parseInt(resp.CurrentPage));
      this._updateHeader(resp, params.col); // pass the column WE sorted by to update header, which may not be the actual column used to sort on backend
      this._rebuildTable(resp.Record);
      if (this.checkCallback)
        this.checkCallback();

      this.p.initialInit = false;

      if ( isUndefinedOrNull( this.p.initialSort ) && !isUndefinedOrNull( this.extraParams[ "initialSort" ] ) ) {
        this.p.initialSort = true;
        var dir = this.extraParams[ "initialSort" ];
        var col = !isUndefinedOrNull( this.extraParams[ "initialSortCol" ] ) ? this.extraParams[ "initialSortCol" ] : null;
        this.Sort( dir, col );
      }

      if ( !!callback )
        callback();

      this.p.$dimmer.hide();
    }).bind(this));
  }).bind(this);
  this.Filter = (function (filterObj) {
    if (typeof(filterObj) != "object")
      return;
    this.filterObj = filterObj
    this.Refresh("filter");
  }).bind(this);

  this.GetAllData = function() {
    return this.p.$tbody.data("raw")
  }
  this.GetRowData = (function (keyValue) {
    return this.GetAllData().find(row => row[this.checkKey] === keyValue)
  }).bind(this);

  // Event handlers
  this.p.$thead.click((function (e) {
    var $el = $(e.target);
    while (!$el.is("th") && $el.length)
      $el = $el.parent();
    if (!$el.length)
      return console.error("Could not locate <th> element.");
    if ($el.attr("data-sortable") == "true") {
      this.sortColumn = $el.attr("data-column-id");
      var $i = $el.find("i.fa");
      this.sortDirection = $i.hasClass("fa-sort-amount-desc") || (! $i.hasClass('fa-sort-amount-asc'));
      this.Refresh('new_sort');
    } else {
      this._showContextMenu($el, e);
    }
  }).bind(this));
  this._showContextMenu = (function ($el, e) {
    var thisThis = this;
    var columnName = $el.attr('data-column-name'),
      sortable = $el.attr('data-sortable') == 'true',
      filterType = $el.attr('data-filter-type'),
      filterCallback = $el.attr('data-filter-callback');

    function contextMenuCallback(option) {
      if (option.value == 'sort-asc') {
        thisThis.sortColumn = $el.attr("data-column-id");
        thisThis.sortDirection = true;
        thisThis.Sort( thisThis.sortDirection, thisThis.sortColumn );
      } else if (option.value == 'sort-desc') {
        thisThis.sortColumn = $el.attr("data-column-id");
        thisThis.sortDirection = false;
        thisThis.Sort( thisThis.sortDirection, thisThis.sortColumn );
      } else /* Filter */{
        function modalCallback(filterFormObj) {
          if (filterFormObj)
            thisThis.Filter(filterFormObj);
        }
        thisThis._filterModal($el, modalCallback)
      }
    }

    popupOptions = [];
    if (sortable) {
      popupOptions.push({title:'<i class="fa fa-sort-amount-asc"/> Sort Ascending', value: 'sort-asc'});
      popupOptions.push({title:'<i class="fa fa-sort-amount-desc"/> Sort Descending', value: 'sort-desc'});
    }
    if (filterType != 0) {
      if (filterCallback && Object.keys(this).indexOf(filterCallback) == -1)
        console.error("The filter callback for column " + columnName + " isn't defined.");
      else
        popupOptions.push({title:'<i class="fa fa-filter"/> Filter Column', value: filterType});
    }
    if (popupOptions.length) {
      popupMenu( columnName + '_popup', {
        callback: contextMenuCallback,
        optionsList: popupOptions,
        event: e } );
    }
  }).bind(this);
  this.p.$thead.contextmenu((function(e) {
    e.preventDefault();
    var $el = $(e.target);
    while (!$el.is("th") && $el.length)
      $el = $el.parent();
    if (!$el.length)
      return console.error("Could not locate <th> element.");

    this._showContextMenu($el, e);
  }).bind(this));
  this.p.$mnuPerpage.click((function (e) {
    e.preventDefault();
    var $t = $(e.target);
    if (!$t.is('a'))
      return;
    this.p.$mnuPerpage.find("li").removeClass("active");
    $t.parent().addClass("active");
    this.perPage = $t.text();
    this.currentPage = 1;
    this.p.$btnPerpage.html(this.perPage + ' per page <span class="caret"></span>');
    this.Refresh('init');
  }).bind(this));
  this.p.$pagination.click((function (e) {
    e.preventDefault();
    var $target = $(e.target);
    if ($target.parent().hasClass('disabled'))
      return;
    else if ($target.parent().hasClass('active'))
      return;
    else if ($target.hasClass('first'))
      this.currentPage = 1;
    else if ($target.hasClass('last'))
      this.currentPage = this.pages;
    else
      this.currentPage = parseInt($target.text());
    this.Refresh();
  }).bind(this));

  this.p.$btnCSV.click((function (e) {
    e.preventDefault();
    this.p.$dimmer.show();
    var params = this._getRequestParams('report');
    params.type = "csv";
    params.reporttitle = this.p.tableTitle + " Report";
    params.visibleColumns = this.visibleColumns;
    Command(params, (function (resp) {
      this.p.$dimmer.hide();
      if (resp.error || !resp.Response)
        return console.error(resp);
      window.open(CURRENT_URL + '/' + this.p.tableTitle.toLowerCase() + '.csv?' + $.param({command: "getfile",
        filename: resp.ReportName}));
    }).bind(this));
  }).bind(this));
  this.p.$btnPDF.click((function (e) {
    e.preventDefault();
    this.p.$dimmer.show();
    var params = this._getRequestParams('report');
    params.type = "pdf";
    params.reporttitle = this.p.tableTitle + " Report";
    params.visibleColumns = this.visibleColumns;
    Command(params, (function (resp) {
      this.p.$dimmer.hide();
      if (resp.error || !resp.Response)
        return console.error(resp);
      window.open(CURRENT_URL + '/' + this.p.tableTitle.toLowerCase() + '.pdf?' + $.param({command: "getfile",
        filename: resp.ReportName}));
    }).bind(this));
  }).bind(this));
  this.p.$btnFilter.click((function (e) {
    e.preventDefault();
    this.filterObj = {};
    this.Refresh( "filter" );
  }).bind(this));

  // "Select all" checkboxes
  this.p.$thead.find("[data-column-type=1] div.th-left").each((function (i, el) {
    var $e = $(el);
    $e.parent().attr('title', 'Select All');
    $e.empty().prepend($('<input type="checkbox"/>').click((function (e) {
      var colIdx = this.ColumnIndex($e.parent().attr("data-column-name"));
      if ($(e.target).prop("checked")) {
        this.p.$tbody.find("td:nth-child(" + colIdx + ") input").each(function (i, el) {
          var $itm = $(el);
          if ($itm.prop("checked"))
            return;
          $itm.click(); // The 'click' event handler will call checkCallback.
        });
      } else {
        this.checked = [];
        this.p.$tbody.find("td:nth-child(" + colIdx + ") input").prop("checked", false);
        if (this.checkCallback)
          this.checkCallback();
      }
    }).bind(this)));
  }).bind(this));

  if ( this.perPage != "25" ) {
    var perPage = this.perPage;
    $( "#Tables3_" + tableName + " .perpage-dropdown a" ).each( function ( i, el ) {
      if ( $( el ).html() == perPage ) {
        $( el ).click();
      }
    } );
  }

  this.Refresh('init');
  this.UpdateColumns();

  if (!this.p.$btnEditColumns.length)
    return; // We're done here.

  // Column arrangement editor
  var modalColEd = {}; {
    var $modal = this.p.$rootNode.find(".tables3-columns-modal");
    modalColEd.save = $modal.attr("data-button-save");
    modalColEd.cancel = $modal.attr("data-button-cancel");
    modalColEd.html = $('<div class="row"/>').html($modal.children()).prop('outerHTML');
    $modal.remove();
  };
  this.p.$btnEditColumns.click((function (e) {
    e.preventDefault();
    var $html = $(modalColEd.html), $columns = $html.find(".columns");
    var thisThis = this;

    function GetColumns() {
      var cols = [];
      $columns.find("input:checked").each(function (i, el) {
        cols.push($(el).parent().attr("data-column-name"));
      });
      return cols;
    }
    function AddColumn(name, str, checked) {
      if (!str)
        return; // No name, ignore.
      $columns.append($("<div/>")
        .attr("data-column-name", name)
        .append($('<input type="checkbox"/>').prop("checked", checked))
        .append("&nbsp;").append(str));
    }
    function GetColumnName(col) {
      var ret =
        thisThis.p.$thead.find('th[data-column-name="' + col + '"] .th-left').text().trim();
      if (!ret)
        console.error("Couldn't find a name for column:", col);
      return ret;
    }

    // Event handlers & reactivation
    $html.find("a[data-bs-toggle='popover']").popover({container: '#contentContainer'});
    $html.find("a.applyto").click(function (e) {
      e.preventDefault();
      var userid = $html.find('select.applyTableSettingsTo').val();
      var columns = GetColumns();
      var data = {
        command: "saveuserpref",
        itemid: tableName,
        preftype: "01",
        type: userid ? "2" : "1",
        userorsecid: userid,
        blobval: JSON.stringify({visible: columns})
      };
      Command(data, (function (resp) {
        if (resp.error)
          return console.error(resp);
        this.visibleColumns = columns;
        this.UpdateColumns();
      }).bind(thisThis));
    });
    $html.find("a.loadfrom").click(function (e) {
      e.preventDefault();
      var userid = $html.find('select.applyTableSettingsTo').val();
      var data = {
        command: "getuserpref",
        itemid: tableName,
        preftype: "01",
        type: userid ? "2" : "1",
        userorsecid: userid
      };
      Command(data, function (resp) {
        if (resp.error)
          return console.error(resp);
        var visible = JSON.parse(resp.BlobVal).visible;
        $columns.empty();
        for (var i in visible) {
          var col = visible[i];
          AddColumn(col, GetColumnName(col), true);
        }
        for (var i in thisThis.p.originalColumns) {
          if (visible.indexOf(thisThis.p.originalColumns[i]) != -1)
            continue;
          var col = thisThis.p.originalColumns[i];
          AddColumn(col, GetColumnName(col), true);
        }
      });
    });
    $html.find(".btnRestoreDefaults").click(function (e) {
      e.preventDefault();
      $columns.empty();
      for (var i in thisThis.p.originalColumns) {
        var col = thisThis.p.originalColumns[i];
        AddColumn(col, GetColumnName(col), true);
      }
    });

    this.p.$thead.children().each(function (i, el) {
      var $e = $(el), col = $e.attr("data-column-name"), str = '';
      if ($e.attr('data-column-type') == '1')
        str = "Select";
      else
        str = $e.find(".th-left").text().trim();
      AddColumn(col, str, thisThis.visibleColumns.indexOf(col) != -1);
    });
    $columns.sortable().disableSelection();
    modalM("Column Settings", $html);
  }).bind(this));
}
